import PropTypes from 'prop-types'
import React, { Fragment, useEffect, useRef, useState } from "react";
import CollectionWithHeader from '../CollectionWithHeader'
import UploadImage from '../UploadImage'
import { CollectionItem, Photo, Tools, ToolsButtons } from './theme'
import {mapImageUrl} from "../../utils/mapImageUrl";

const stopPropagation = cb => e => {
  e.stopPropagation()
  return cb(e)
}

const CollectionWallpapers = ({
  title = '',
  isLoading,
  errMessage,
  photos,
  withUpload,
  action,
                                aspect,
  croped = false,
  calibrated = true,
  onlySystem,
  onDrop,
}) => {

  return (
    <CollectionWithHeader title={title} errMessage={errMessage} isLoading={isLoading}>
      {withUpload === true && (
        <CollectionItem>
          <UploadImage key={'upload-image'} onDrop={onDrop}/>
        </CollectionItem>
      )}

      {photos.map(photo => (
        <CollectionItem key={photo.src} onClick={() => action.active(photo.index)}>
          <Photo className={'loading-img'} src={photo.src} alt={photo.alt}/>

          {!onlySystem && (
            <Fragment><Tools isActive={photo.isSelected && calibrated}>
            <ToolsButtons onClick={stopPropagation(() => action.crop('background'))}>Kadruj</ToolsButtons>
          </Tools>
          <Tools isActive={photo.isSelected && croped}>
            <ToolsButtons style={{backgroundColor: "#fea911"}} onClick={stopPropagation(() => action.calibrate())}>Kalibruj</ToolsButtons>
          </Tools></Fragment>
          )}
          <Tools isActive={photo.isActive === true && photo.isSelected === false}>
            <ToolsButtons onClick={stopPropagation(() => action.select(photo, photo.index))}>
              Wybierz
            </ToolsButtons>
            {!onlySystem &&
            <ToolsButtons onClick={stopPropagation(() => action.remove(photo.index))}>Usuń</ToolsButtons>}
          </Tools>
        </CollectionItem>
      ))}
    </CollectionWithHeader>
  )
}
CollectionWallpapers.propTypes = {
  title: PropTypes.string,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      isSelected: PropTypes.bool,
      isActive: PropTypes.bool,
    })
  ),
  withUpload: PropTypes.bool,
  action: PropTypes.shape({
    select: PropTypes.func.isRequired,
    active: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    crop: PropTypes.func.isRequired,
  }).isRequired,
  onlySystem: PropTypes.bool.isRequired,
  onDrop: PropTypes.func.isRequired,
}

export default CollectionWallpapers



// WEBPACK FOOTER //
// ./src/components/CollectionWallpapers/index.js